webpackJsonp([1],{

/***/ 31:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(72)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(37),
  /* template */
  __webpack_require__(79),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-33502b93",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 32:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Start__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_Start___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_Start__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [{
        path: '/',
        name: 'Start',
        component: __WEBPACK_IMPORTED_MODULE_2__pages_Start___default.a
    }]
}));

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(74)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(36),
  /* template */
  __webpack_require__(81),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 34:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(32);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
    render: function render(h) {
        return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
    }
});

/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return shuffle; });
var shuffle = function shuffle(array) {
    var m = array.length,
        t = void 0,
        i = void 0;

    while (m) {
        i = Math.floor(Math.random() * m--);

        t = array[m];
        array[m] = array[i];
        array[i] = t;
    }

    return array;
};



/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'app'
});

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'button',
    props: {
        type: String
    },
    methods: {
        doClick: function doClick() {
            this.$emit('click');
        }
    }
});

/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_helpers__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Button__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Button__);







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'draw-from-sets',
    props: {
        lottery: {
            type: Object
        }
    },
    components: {
        MyButton: __WEBPACK_IMPORTED_MODULE_3__components_Button___default.a
    },
    computed: {
        lotteryExtended: function lotteryExtended() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.lottery);
        }
    },
    methods: {
        extendRange: function extendRange(arr) {
            var top = arr[1] + 1;
            var bottom = arr[0];
            if (arr[0] === 0) {
                bottom = 0;
            }
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(top).keys()).splice(bottom, top);
        },
        draw: function draw() {
            this.lottery.sets.forEach(function (e, i, a) {
                var _e$drawn;

                var pool = e.extended.slice(0);
                var count = e.draw;
                var locked = [];
                if (e.locked.length > 0) {
                    e.locked.forEach(function (e) {
                        var index = pool.indexOf(e);
                        pool.splice(index, 1);
                        count--;
                        locked.push(e);
                    });
                }
                e.drawn = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_helpers__["a" /* shuffle */])(pool).splice(0, count);
                (_e$drawn = e.drawn).push.apply(_e$drawn, locked);
            });
        },
        toggleLock: function toggleLock(set, num, setIndex) {
            if (set.locked.indexOf(num) === -1) {
                if (set.locked.length < this.lotteryExtended.sets[setIndex].draw) {
                    set.locked.push(num);
                }
            } else {
                var index = set.locked.indexOf(num);
                set.locked.splice(index, 1);
            }
        },
        isDrawn: function isDrawn(set, num) {
            return set.drawn.indexOf(num) >= 0;
        },
        isLocked: function isLocked(set, num) {
            return set.locked.indexOf(num) >= 0;
        }
    },
    created: function created() {
        var _this = this;

        var that = this;
        this.lotteryExtended.sets.forEach(function (e, i, a) {
            that.$set(e, 'extended', _this.extendRange(e.range));
            that.$set(e, 'drawn', []);
            that.$set(e, 'locked', []);
        });
    }
});

/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Button__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Button__);




/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'sequence',
    props: {
        lottery: {
            type: Object
        }
    },
    components: {
        MyButton: __WEBPACK_IMPORTED_MODULE_1__components_Button___default.a
    },
    data: function data() {
        return {
            sequence: []
        };
    },

    methods: {
        generateSequence: function generateSequence() {
            var seq = [];
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(Array(this.lottery.length)).forEach(function () {
                seq.push(Math.floor(Math.random() * 9));
            });
            this.sequence = seq;
        }
    }
});

/***/ }),

/***/ 40:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DrawFromSets__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_DrawFromSets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_DrawFromSets__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Sequence__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Sequence___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Sequence__);





/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        DrawFromSets: __WEBPACK_IMPORTED_MODULE_0__components_DrawFromSets___default.a,
        Sequence: __WEBPACK_IMPORTED_MODULE_1__components_Sequence___default.a
    },
    data: function data() {
        return {
            sets: [{
                name: 'EuroJackpot',
                sets: [{
                    label: 'Zahlen',
                    draw: 5,
                    range: [1, 50]
                }, {
                    label: 'Eurozahlen',
                    draw: 2,
                    range: [1, 10]
                }]
            }, {
                name: 'Lotto 6 aus 49',
                sets: [{
                    label: 'Zahlen',
                    draw: 6,
                    range: [1, 49]
                }, {
                    label: 'Superzahl',
                    draw: 1,
                    range: [0, 9]
                }]
            }, {
                name: 'EuroMillions',
                sets: [{
                    label: 'Zahlen',
                    draw: 5,
                    range: [1, 50]
                }, {
                    label: 'Sterne',
                    draw: 2,
                    range: [1, 12]
                }]
            }, {
                name: 'Cash4Life',
                sets: [{
                    label: 'Zahlen',
                    draw: 5,
                    range: [1, 60]
                }, {
                    label: 'Zusatzzahlen',
                    draw: 1,
                    range: [1, 4]
                }]
            }],
            sequences: [{
                name: 'World Millions',
                length: 8
            }]
        };
    }
});

/***/ }),

/***/ 71:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 72:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 73:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 74:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 75:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(71)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(38),
  /* template */
  __webpack_require__(78),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-29ef1fa0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(73)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(80),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-531be33c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(82),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 78:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lottery"
  }, [_c('h2', [_vm._v(_vm._s(_vm.lotteryExtended.name))]), _vm._v(" "), _vm._l((_vm.lotteryExtended.sets), function(set, index) {
    return _c('dl', [_c('dt', {
      domProps: {
        "textContent": _vm._s(set.label || 'Set ' + (index + 1))
      }
    }), _vm._v(" "), _c('dd', [_c('ul', {
      staticClass: "set"
    }, _vm._l((set.extended), function(number) {
      return _c('li', {
        staticClass: "set__number",
        class: {
          'drawn': _vm.isDrawn(set, number), 'locked': _vm.isLocked(set, number)
        },
        on: {
          "click": function($event) {
            _vm.toggleLock(set, number, index)
          }
        }
      }, [_vm._v("\n                    " + _vm._s(number) + "\n                ")])
    }))])])
  }), _vm._v(" "), _c('my-button', {
    on: {
      "click": _vm.draw
    }
  }, [_vm._v("Zufallszahlen generieren")])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 79:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    attrs: {
      "type": _vm.type
    },
    on: {
      "click": _vm.doClick
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 80:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lottery"
  }, [_c('h2', [_vm._v(_vm._s(_vm.lottery.name))]), _vm._v(" "), _c('dl', [_c('dt', {
    domProps: {
      "textContent": _vm._s(_vm.lottery.name || 'Sequenz ' + (_vm.index + 1))
    }
  }), _vm._v(" "), _c('dd', {
    staticClass: "sequence"
  }, _vm._l((_vm.sequence), function(number) {
    return _c('input', {
      attrs: {
        "type": "number",
        "min": "0",
        "max": "9"
      },
      domProps: {
        "value": number
      }
    })
  }))]), _vm._v(" "), _c('my-button', {
    on: {
      "click": _vm.generateSequence
    }
  }, [_vm._v("Zufallszahlen generieren")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 81:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('main', [_c('router-view')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('span', [_vm._v("luckyme")])])
}]}

/***/ }),

/***/ 82:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.sets), function(lottery) {
    return _c('draw-from-sets', {
      key: lottery.name,
      attrs: {
        "lottery": lottery
      }
    })
  }), _vm._v(" "), _vm._l((_vm.sequences), function(lottery) {
    return _c('sequence', {
      key: lottery.name,
      attrs: {
        "lottery": lottery
      }
    })
  })], 2)
},staticRenderFns: []}

/***/ })

},[34]);


// WEBPACK FOOTER //
// static/js/app.8f55076d493b9301a677.js